import { useEffect, useState } from "react";
import {
  Grid,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItemButton,
  ListItem,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RemoveDialog from "./RemoveDialog";

import formatDate from "../../../../../utilities/formatDate";
import request from "../../../../../utilities/requests";
import { toast } from "../../../../../utilities/SnackBarUtils";

const RegisteredEvents = ({ user }) => {
  const [events, setEvents] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);

  const getEvents = async () => {
    try {
      setLoading(true);
      const result = await request(`events/admingetevents?userId=${user._id}`);
      if (result?.success) {
        setEvents(result.events || []);
      } else {
        toast.error(result?.message || "Failed to load events.");
      }
    } catch (err) {
      toast.error("Failed to load events.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmClose = (action) => {
    if (action === "confirm") {
      handleRemove(selectedEvent);
    }
    setConfirmOpen(false);
  };

  const handleRemove = async (event) => {
    const body = {
      userId: user._id,
      eventId: event._id,
    };

    const result = await request("events/removeattendee", "post", body);
    if (result.success) {
      getEvents();
      toast.success("User removed from event");
    }
  };

  return (
    <Grid item xs={12}>
      <Paper height={3}>
        <Accordion
          expanded={expanded}
          onChange={(_, isExpanded) => {
            setExpanded(isExpanded);
            if (isExpanded && events.length === 0 && user?._id) {
              getEvents();
            }
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <ListItemButton style={{ fontWeight: "bold" }}>
              Registered Events
            </ListItemButton>
          </AccordionSummary>

          <AccordionDetails>
            {loading ? (
              <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: 24 }}>
                <CircularProgress size={24}/>
              </div>
            ) : (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {events.length === 0 ? (
                  <Typography variant="body2" color="text.secondary" sx={{ p: 1 }}>
                    No registered events found.
                  </Typography>
                ) : (
                  events.map((event) => {
                    return (
                      <div
                        key={`${event._id}`}
                        style={{
                          padding: 10,
                          display: "flex",
                          alignItems: "center",
                          gap: 30,
                          width: "100%",
                        }}
                      >
                        <Typography>
                          {event?.name} | {formatDate(event?.date)}
                        </Typography>
                        <Button
                          size="small"
                          variant="outlined"
                          style={{ width: 100, marginLeft: 20 }}
                          onClick={() => {
                            setSelectedEvent(event);
                            setConfirmOpen(true);
                          }}
                        >
                          remove
                        </Button>
                      </div>
                    );
                  })
                )}
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </Paper>
      <RemoveDialog
        open={confirmOpen}
        close={handleConfirmClose}
        user={user}
        event={selectedEvent}
      />
    </Grid>
  );
};

export default RegisteredEvents;
